"use client"

import { useTheme } from "@emotion/react"
import styled from "@emotion/styled"
import Link from "next/link"
import { useState } from "react"
import { extractProperty, footerMenuClick } from "utils"
import { Desktop } from "../../common/bit/MediaQueries"
import { SocialIcon } from "../../icons"

const StyledSocials = styled.div`
  display: flex;
  gap: 24px;
`
const Social = styled.div<{ hover: boolean }>`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => p.theme.colors.footerSocialsBackgroundColor};
  border-radius: 100%;
`

function Icon({
  type,
  companyName,
}: {
  type: "instagram" | "linkedin" | "facebook" | "youtube"
  companyName?: string
}) {
  const [hover, setHover] = useState(false)
  const theme = useTheme()
  return (
    <Social hover={hover} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <SocialIcon
        width="40"
        height="40"
        fill={theme.colors.socialColor}
        type={type}
        hover={hover}
        companyName={companyName}
      />
    </Social>
  )
}
type Props = {
  desktopSocialUrls: any
  companyName?: string
}

function SocialsDesktop({ desktopSocialUrls, companyName }: Props) {
  return (
    <Desktop>
      <StyledSocials>
        {desktopSocialUrls.map((item: any, index: number) => {
          const link = extractProperty(item, "link")

          const type = extractProperty(item, "selectSocialIcon") as
            | "instagram"
            | "linkedin"
            | "facebook"
            | "youtube"

          if (!link?.[0]?.url) return null

          return (
            <Link
              key={index.toString()}
              style={{ width: 40, height: 40 }}
              href={link?.[0]?.url || "#"}
              onClick={() => footerMenuClick(type, "")}
              target="_blank"
              aria-label={
                type === "instagram"
                  ? "אינסטגרם"
                  : type === "facebook"
                    ? "פייסבוק"
                    : type === "youtube" || type.toLowerCase() === "youtube"
                      ? "יוטיוב"
                      : "לינקדאין"
              }
            >
              <Icon type={type} companyName={companyName} />
            </Link>
          )
        })}
      </StyledSocials>
    </Desktop>
  )
}

export default SocialsDesktop
